import { Entry, Locale } from 'contentful';
import IRegion from '@app/types/base/IRegion';
import { TypeRegionSkeleton } from '@/@types/generated/contentful';
import MultiLocaleService from './base/MultiLocaleService';

export default class RegionService extends MultiLocaleService {
	public async getRegions(): Promise<Record<string, IRegion[]>> {
		const regions = await this.deliveryClient.withAllLocales.getEntries<TypeRegionSkeleton>({
			// eslint-disable-next-line @typescript-eslint/naming-convention
			content_type: 'region',
		});

		const regionsByLocaleCode: Record<string, IRegion[]> = {};

		this.locales.forEach((locale: Locale): void => {
			regionsByLocaleCode[locale.code] = regions.items.map(
				(regionEntry: Entry<any>): IRegion => {
					const region: IRegion = {
						...this.mapToSingleLocaleObject(regionEntry.fields, locale),
						id: regionEntry.sys.id
					};

					return region;
				}
			);
		});

		return regionsByLocaleCode;
	}
}
